import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { userApi } from "../api/user";
import { HOME_NAV_ITEM } from "../types/navItem";
import { isIntroSeen } from "./OnboardingIntro";

/**
 * "/" 진입 게이트 — 별도 로고 스플래시 없음(네이티브 스플래시가 로고 담당).
 * 인증만 확인해 로그인됨→메인홈 / 아니면→웰컴(/login)으로 즉시 이동.
 * 화면은 크림(#FAF6EF) 배경만 → 네이티브 스플래시→목적지 전환이 매끄럽게(깜빡임·로딩 없음).
 */
const Splash: React.FC = () => {
  const navigate = useNavigate();
  const { initAuth, setUserId, setProfileImage, clearAuth } = useAuthStore();

  useEffect(() => {
    document.body.classList.remove("bg-backgroundColorBg2");

    initAuth();
    const token = localStorage.getItem("auth_token");

    const runAuthAndNavigate = async () => {
      if (token) {
        try {
          const response = await userApi.getProfile();
          setUserId(response.user.id);
          setProfileImage(response.user.profile_image || null);
        } catch (error: any) {
          if (error.response?.status === 401) {
            clearAuth();
          }
        }
      }
      const { isAuthenticated } = useAuthStore.getState();
      // 온보딩 미열람이면 로그인 여부와 무관하게 최초 1회 3스텝 온보딩 먼저.
      // 열람 후: 로그인됨→홈 / 비로그인→Welcome. (온보딩 종료 분기도 동일)
      if (!isIntroSeen()) {
        navigate("/onboarding-intro", { replace: true });
      } else {
        navigate(isAuthenticated ? HOME_NAV_ITEM.path : "/login", {
          replace: true,
        });
      }
    };

    runAuthAndNavigate();

    return () => {
      document.body.classList.add("bg-backgroundColorBg2");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 로고 스플래시 제거 — 크림 배경만(전환용)
  return (
    <div className="w-full h-full" style={{ backgroundColor: "#FAF6EF" }} />
  );
};

export default Splash;
